"use strict";
var click_outside_directive_1 = require('./click-outside.directive');
exports.ClickOutsideDirective = click_outside_directive_1.ClickOutsideDirective;
var click_outside_module_1 = require('./click-outside.module');
exports.ClickOutsideModule = click_outside_module_1.ClickOutsideModule;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-click-outside/lib/index.js
// module id = ./node_modules/ng2-click-outside/lib/index.js
// module chunks = vendor